import { Api } from './api';
import { IInvoice, IInvoiceQuote } from '@/types/types';

export const listInvoices = <T>(query: string): Promise<T> => {
  return Api().get(`/invoices${query ? query : ''}`);
};

export const invoiceDetails = <T>(id: number): Promise<T> => {
  return Api().get(`/invoices/${id}`);
};

/** what an amount buys, before committing to an invoice */
export const quoteInvoice = <T = IInvoiceQuote>(amount: number): Promise<T> => {
  return Api().get(`/invoices/quote?amount=${amount}`);
};

export const issueInvoice = <T = IInvoice>(payload: {
  amount: number;
  recipientMsisdn?: string;
  description?: string;
}): Promise<T> => {
  return Api().post(`/invoices`, payload);
};

/** collect payment for an invoice; the amount comes from the invoice itself */
export const payInvoice = <T>(
  id: number,
  payload: { recipientMsisdn?: string; network?: string; payer?: string }
): Promise<T> => {
  return Api().post(`/invoices/${id}/pay`, payload);
};

export const cancelInvoice = <T = IInvoice>(id: number): Promise<T> => {
  return Api().post(`/invoices/${id}/cancel`, {});
};
